import Vue from 'vue'
import Router from 'vue-router'
import RegionManage from '@/views/RegionManage.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login.vue')
    },
    {
      path: '/',
      name: 'Dashboard',
      component: () => import('../views/Dashboard.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: 'coach',
          name: 'CoachManage',
          component: () => import('../views/CoachManage.vue')
        },
        {
          path: 'car',
          name: 'CarManage',
          component: () => import('../views/CarManage.vue')
        },
        {
          path: 'timeslot',
          name: 'TimeSlotManage',
          component: () => import('../views/TimeSlotManage.vue')
        },
        {
          path: 'order',
          name: 'OrderManage',
          component: () => import('../views/OrderManage.vue')
        },
        {
          path: 'user',
          name: 'UserManage',
          component: () => import('../views/UserManage.vue')
        },
        {
          path: 'face-recognition',
          name: 'FaceRecognitionManage',
          component: () => import('../views/FaceRecognitionManage.vue')
        },
        {
          path: 'region',
          name: 'RegionManage',
          component: RegionManage
        },
        {
          path: 'account',
          name: 'AccountManage',
          component: () => import('../views/AccountManage.vue')
        }
      ]
    }
  ]
}) 